import React, { useContext, useEffect, useRef, useState } from "react";
import "./AddCircle.css";
import { ramlKey } from "../../data";
import { AddCircleContext } from "../../contexts/AddCircleContext";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import apiUrl from "../../utils/ApiConfig";

export default function AddCircle() {
  const [ramlData, setRamlData] = useState(ramlKey);
  const [imgsrc, setImgSrc] = useState([]);
  const [inValue1, setInValue1] = useState("");
  const [resobj, setResObj] = useState({});
  const circleContext = useContext(AddCircleContext);
  const [flagimgreset, setFlagImgReset] = useState(true); // flag to reset image position
  const [flagAddImgPutApi, setFlagAddImgPutApi] = useState(false); // flag to reset image position
  const dRef = useRef();
  const submitHandler = (e) => {
    e.preventDefault();
    // change array of circle code to string by join() method =>>>
    let string = circleContext.dayerhCode.join("");
    let dateModife = new Date();
    let obj = {
      ID: 1,
      Name: inValue1,
      Order: `${imgsrc}`, //  <<==to send src and get img in other side
      // Order:`${string}`,   //  <<==to send code of every raml and get in othet side
      IsVisible: true,
      LastModified: dateModife,
    };
    let obj2 = {
      ID: circleContext.idToApiPut,
      Name: inValue1,
      Order: `${imgsrc}`, //  <<==to send src and get img in other side
      // Order:`${string}`,   //  <<==to send code of every raml and get in othet side
      IsVisible: true,
      LastModified: dateModife,
    };
    // PUT-api method==>>
    async function myApp2() {
      const response = await fetch(
        `${apiUrl}/api/Dayerehs/{id}?id=${circleContext.idToApiPut}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj2),
        }
      ).then((response) => console.log(response));
      circleContext.setAddCirFlag((prev) => !prev);

      // to update state of get api ==>
      // circleContext.setAddCirFlag(prev => !prev)
    }
    // POST-api method==>>
    async function myApp() {
      const response = await fetch(
        `${apiUrl}/api/Dayerehs`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(obj),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setResObj(data);
          // to update state of get api ==>
          circleContext.setAddCirFlag((prev) => !prev);
        });
    }
    if (circleContext.addCirFlag3) {
      myApp2();
      setImgSrc([]);
      setInValue1("");
      dRef.current.classList.remove("hide2");
      setFlagAddImgPutApi(false);
      circleContext.setAddCirFlag3(false);
    } else {
      myApp();
      setInValue1("");
      setImgSrc([]);
      circleContext.SetDayerhCode([]); // <==to empty the orderCode Array
      // to reset img position==>
      setFlagImgReset(false);
      setTimeout(() => {
        setFlagImgReset(true);
      }, 0.001);
    }

    circleContext.setAddCirFlag3(false);
  };
  ///////////////////
  const resetImgHandler = () => {
    setInValue1("");
    // setInValue2('')
    setImgSrc([]);
    setFlagImgReset(false);
    circleContext.setAddCirFlag3(false);
    setFlagAddImgPutApi(false);
    dRef.current.classList.remove("hide2");
    setTimeout(() => {
      setFlagImgReset(true);
    }, 0.001);
  };
  ///////////////////////
  const changeValu1 = (e) => {
    setInValue1(e.target.value);
  };
  ///////////////////////
  const addImgPutApi = () => {
    setFlagAddImgPutApi(true);
    dRef.current.classList.add("hide2");
    setImgSrc([circleContext.srcToApiPut[0].Order]);
  };
  ////////////////////////
  function imgClick2(event, f) {
    //do with event

    let y = ramlData.filter((item) => item.src === f);
    setImgSrc((prev) => [...prev, y[0].src]);
    event.target.classList.add("hide");
    // setInValue1(circleContext.srcToApiPut[0].Name)
  }

  function imgClick(event, d) {
    //do with event
    let x = d;
    let y = ramlData.filter((item) => item.keyA === d);
    setImgSrc((prev) => [...prev, y[0].src]);
    // circleContext.SetDayerhCode(prev => [...prev, x])          <<== to make key Order api Object
    // setImgId(x)
    // e.target.remove()
    event.target.classList.add("hide");
  }
  //////////////////////
  useEffect(() => {
    if (circleContext.addCirFlag3) {
      setInValue1(circleContext.srcToApiPut[0].Name);
    }
  }, [circleContext.addCirFlag3, circleContext.addCirFlag4]);
  /////////////////////
  useEffect(() => {
    setImgSrc([]);
    setFlagAddImgPutApi(false);
    dRef.current.classList.remove("hide2");

    circleContext.setAddCirFlag3(false);
  }, [circleContext.addCirFlag5]);
  //////////////////////////////////

  return (
    <div className="container-addcircom">
      <div className="addcircle-rectangle">
        <div className="container">
          <div className="row row-cols-4 addcirrectangle-row" ref={dRef}>
            {!circleContext.addCirFlag3 &&
              flagimgreset &&
              ramlData.map((item) => (
                <div className="col" key={`${item.keyA}`}>
                  <img
                    id={`${item.keyA}`}
                    className="addcircom-img remov"
                    src={item.src}
                    alt=""
                    onClick={(e) => {
                      imgClick(e, `${item.keyA}`);
                    }}
                  />
                </div>
              ))}
            {/* //or////////////////////////////// */}
            {circleContext.addCirFlag3 &&
              circleContext.srcToApiPut[0].Order.split(",").map((item) => (
                <div className="col">
                  <img
                    id={`${circleContext.srcToApiPut[0].ID}`}
                    className="addcircom-img remov"
                    src={item}
                    alt=""
                    onClick={(e) => {
                      imgClick2(e, `${item}`);
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      {/* imgClick(c) */}

      {circleContext.addCirFlag3 && (
        <div>
          <img
            onClick={addImgPutApi}
            className="addcircle-arrowimg"
            src="./images/blue-arrow-down-icon-png-27.png"
            alt=""
          />
        </div>
      )}

      <div className="addcircle-square">
        <div className="container">
          <div className="row row-cols-4  addcirsquare-row">
            {!flagAddImgPutApi &&
              imgsrc.map((item, index) => (
                <div className="col ">
                  <img
                    key={index}
                    src={item}
                    className="addcircom-img2"
                    alt=""
                  />
                </div>
              ))}
            {flagAddImgPutApi &&
              circleContext.srcToApiPut[0].Order.split(",").map((item) => (
                <div className="col">
                  <img
                    id={`${circleContext.srcToApiPut[0].ID}`}
                    className="addcircom-img remov"
                    src={item}
                    alt=""
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="addcircle-resetimg" onClick={resetImgHandler}>
        <RestartAltIcon />
      </div>

      {/* <button onClick={addImgPutApi}>++++</button> */}

      <div className="addcircle-form">
        <div className="container">
          <div className="row">
            <div className="col addcircl-col">
              <form className="addcircle-form" onSubmit={submitHandler}>
                <div className="addcircle-label-float">
                  <input
                    type="text"
                    placeholder=""
                    onChange={changeValu1}
                    value={inValue1}
                  />
                  <label>نام دایره</label>
                </div>
                {flagAddImgPutApi && inValue1 ? (
                  <button className="addcirclecom-button">
                    {" "}
                    <span>افزودن</span>{" "}
                  </button>
                ) : imgsrc.length == 16 && inValue1 ? (
                  <button className="addcirclecom-button">
                    {" "}
                    <span>افزودن</span>{" "}
                  </button>
                ) : (
                  <button
                    className="addcirclecom-button addcirclopacity "
                    disabled="disabled"
                  >
                    {" "}
                    <span>افزودن</span>{" "}
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
